import { ModQuickDissolve } from '@components/arsenal/mods/ModQuickDissolve';
import { ModResonite } from '@components/arsenal/mods/ModResonite';
import { ArsenalHeader } from '@components/arsenal/ArsenalHeader';
import { Mod } from '@components/arsenal/mods/Mod';
import { Button } from '@components/ui/Button';
import { useTranslation } from 'react-i18next';
import { combineMods } from '@helpers/mods';
import { useAppStore } from '@stores';
import { useState } from 'react';

export function ArsenalMods() {
  const [showQuickDissolve, setShowQuickDissolve] = useState(false);

  const { t } = useTranslation(undefined, { keyPrefix: 'Arsenal.Mods' });
  const { t: tMods } = useTranslation(undefined, { keyPrefix: 'Mods' });
  const { userData } = useAppStore();

  const mods = userData.mods
    .sort((a, b) => {
      return tMods(`Mods.${a.key}.name`).localeCompare(tMods(`Mods.${b.key}.name`));
    });

  const combinedMods = combineMods(mods, userData);
  const canQuickDissolve = combinedMods.some(m => m.rank === 0 && m.count > 1);

  return (
    <>
      <ModQuickDissolve onClose={() => setShowQuickDissolve(false)} open={showQuickDissolve} />

      <div className="flex flex-col h-full overflow-hidden">
        <ArsenalHeader description={t('description')} title={t('title')} bg="mods.avif" />
        <ModResonite />

        {canQuickDissolve && (
          <Button onClick={() => setShowQuickDissolve(true)} className="bg-gray-900 border-x-0">
            {t('quickDissolve')}
          </Button>
        )}

        <div className="flex-1 overflow-y-auto p-2">
          <div className="grid grid-cols-2 lg:grid-cols-3 gap-2">
            {combinedMods.map((mod) => (
              <Mod equipped={mod.equipped} count={mod.count} key={mod.id} mod={mod} />
            ))}
          </div>

          {mods.length === 0 && (
            <div className="text-center text-sm text-gray-300 p-2">
              {t('empty')}
            </div>
          )}
        </div>
      </div>
    </>
  );
}